import { render } from "./vrecpositionedit.vue?vue&type=template&id=362062ed&scoped=true"
import script from "./vrecpositionedit.vue?vue&type=script&lang=js"
export * from "./vrecpositionedit.vue?vue&type=script&lang=js"

import "./vrecpositionedit.vue?vue&type=style&index=0&id=362062ed&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-362062ed"]])

export default __exports__